var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}}),(_vm.isLoggedIn)?_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1):_vm._e(),(!_vm.$route.meta.keepAlive||!_vm.isLoggedIn)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }